module.exports = __webpack_public_path__ + "static/media/IMG-18.a5ce3f7a.jpg";